<template>
    <div class="container-fluid">
        <div class="row">
            <Menu />
            <div class="col-md-10 mt-4">
                <h1>
                    <i class="fa-solid fa-diagram-project"></i> Gerar Relatório 1
                </h1> 
                <hr />
                <div class="cont mt-4" style="padding:20px; border-radius:10px;">
                    <form class="form" @submit.prevent="handleGrafico">
                        <div class="row">
                            <div class="col-md-3">
                                <label>Selecione o Projeto</label>
                                <select class="form-control" v-model="projetoSelecionado" @change="filtrarCredores"> 
                                    <option value="" disabled>Selecione um projeto</option>
                                    <option v-for="reck in dadosProjeto" :value="reck.id" :key="reck.id">{{ reck.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-3">                  
                                <label>Selecione o Credor</label>
                                <select v-model="credorSelecionado" class="form-control" @change="atualizarFormulario"> 
                                    <option value="" ></option>
                                    <option v-for="reck in credoresFiltrados" :value="reck.id">{{ reck.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-12 mt-3">
                                <button class="btn btn-primary">Gerar Relatório</button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="cont mt-4 p-4 rounded" v-if="exibeForm">
                    <div class="col-md-12">
                        <ul class="dashReck d-flex justify-content-center gap-3 list-unstyled">
                            <li @click="exibeTabelaFuncao('todos')" class="p-3 text-center rounded" style="background-color: #93806A !important; color: white;">
                                <span>{{ totalEmitidas }}</span> <br />Total de Parcelas
                            </li>
                            <li @click="exibeTabelaFuncao('pagos')" class="p-3 text-center rounded border">
                                <span >{{ totalPagas }}</span> <br />Parcelas Pagas
                            </li>
                            <li @click="exibeTabelaFuncao('pendente')" class="p-3 text-center rounded border">
                                <span >{{ totalNaoPagas }}</span> <br />Parcelas Pendentes
                            </li>
                        </ul>
                        <table v-if="exibePendentes" class="table containeer mt-5">
                                        <thead>
                                            <tr>
                                                <th>Vencimento</th>
                                                <th>Valor</th>
                                                <th v-if="!credorSelecionado">Credor</th>
                                                <th>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="reck in informacoes.reck2.total_pendentes_lista" :key="reck.id">
                                                <td>{{ handleData(reck.inicio_parcela)  }}</td>
                                                <td>R$ {{reck.valor_parcela }}</td>
                                                <td v-if="!credorSelecionado"><td>{{ credoresFiltrados.find(credor => credor.id === reck.id_credor).name || 'Desconhecido' }}</td>                                            </td>
                                                <td v-html="reck.situacao == 2 ? '<div class=\'alert alert-warning\'>Aguardando Pagamento</div>' : '<div class=\'alert alert-success\'>Pago</div>'"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                        <table v-if="exibePagos" class="table containeer mt-5">
                                        <thead>
                                            <tr>
                                                <th>Vencimento</th>
                                                <th>Valor</th>
                                                <th v-if="!credorSelecionado">Credor</th>
                                                <th>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="reck in informacoes.reck2.total_pagas_lista" :key="reck.id">
                                                <td>{{ handleData(reck.inicio_parcela)  }}</td>
                                                <td>R$ {{reck.valor_parcela }}</td>
                                                <td v-if="!credorSelecionado"><td>{{ credoresFiltrados.find(credor => credor.id === reck.id_credor).name || 'Desconhecido' }}</td>                                            </td>
                                                <td v-html="reck.situacao == 2 ? '<div class=\'alert alert-warning\'>Pendente</div>' : '<div class=\'alert alert-success\'>Pago</div>'"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                        <table v-if="exibeTodos" class="table containeer mt-5">
                                        <thead>
                                            <tr>
                                                <th>Vencimento</th>
                                                <th>Valor</th>
                                                <th v-if="!credorSelecionado">Credor</th>
                                                <th>Situação</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="reck in informacoes.reck2.total_lista" :key="reck.id">
                                                <td>{{ handleData(reck.inicio_parcela)  }}</td>
                                                <td>R$ {{reck.valor_parcela }}</td>
                                                <td v-if="!credorSelecionado"><td>{{ credoresFiltrados.find(credor => credor.id === reck.id_credor).name || 'Desconhecido' }}</td>                                            </td>
                                                <td v-html="reck.situacao == 2 ? '<div class=\'alert alert-warning\'>Pendente</div>' : '<div class=\'alert alert-success\'>Pago</div>'"></td>
                                            </tr>
                                        </tbody>
                                    </table>
                        

                        <ul class="" v-if="informacoes.desagio">
                            <li>Deságio: <b>{{ informacoes.desagio }}</b></li>
                            <li>Carência: <b>{{ informacoes.carencia }}</b></li>
                            <li>Taxa: <b>{{ informacoes.taxa }}</b></li>
                            <li>Total de Parcelas: <b>{{ informacoes.total_parcelas }}</b></li>
                            <li>Homologação: <b>{{ handleData(informacoes.homologado) }}</b></li>
                            <li>Valor Original: <b>R$ {{ informacoes.valor_original }}</b></li>
                            <li>Valor com Deságio: <b>{{ valorDesagio }}</b></li>
                        </ul>
                    </div>
                    
                    <hr>

                    <div class="col-md-7 mx-auto text-center">
                        <label class="mb-3">Parcelas <b>Pagas</b> e Não <b>Pagas</b></label>
                        <hr>
                        <canvas ref="chartCanvas"></canvas>
                    </div>
                </div>

            </div>
        </div>
    </div>
    </template>
    
    <script setup>
    import { ref, onMounted, computed } from "vue";
    import { Chart, registerables } from 'chart.js';
    import Menu from "@/components/Menu.vue";
    import grafico from "@/servicos/grafico";
    import projetos from '@/servicos/projetos';
    import { useRouter } from "vue-router";
    import moment from "moment";

    const totalPagas = ref(0)
    const totalNaoPagas = ref(0)
    const totalEmitidas = ref(0)
    const valorDesagio = ref(0)
    const exibeForm = ref(false);
    const exibePendentes = ref(false);
    const exibePagos = ref(false);
    const exibeTodos = ref(false);
    const nomeCredor = ref(false)

    const informacoes = ref({
        "desagio": '',
        "carencia": '',
        "taxa": '',
        "total_parcelas": '',
        "homologado": '',
        "valor_original": '',
        "reck2": []
    })

    let chartInstance = null; // Armazena a instância do gráfico
    Chart.register(...registerables);

    const chartCanvas = ref(null);
    const credorSelecionado = ref('')

    const handleGrafico = () => {
        faturasPagasEnao(projetoSelecionado.value, credorSelecionado.value ?? null)
        exibeForm.value = true
    }

    const atualizarFormulario = () => {
    exibeForm.value = false;
};
    
const handleData = (value) => {
    return moment(value).format('DD/MM/YYYY')
}
const exibeTabelaFuncao = (value) => {
    if (value === "pendente") {
        exibePendentes.value = !exibePendentes.value;
        exibePagos.value = false;
        exibeTodos.value = false;
    } else if (value === "pagos") {
        exibePagos.value = !exibePagos.value;
        exibePendentes.value = false;
        exibeTodos.value = false;
    } else if (value === "todos") {
        exibeTodos.value = !exibeTodos.value;
        exibePendentes.value = false;
        exibePagos.value = false;
    }
};



    const faturasPagasEnao = async (value, credor) => {
        if (chartInstance) {
                chartInstance.destroy();
            }

        const response = await grafico.faturas_pagas_nao(value, credor ?? null)

        const valorD = response.data.relatorio;

        let totalValor = 0;
            valorD.forEach(element => {
            totalValor += parseFloat(element.valor_parcela);
        })

        valorDesagio.value = totalValor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

        informacoes.value.desagio = response.data.relatorio[0].desagio
        informacoes.value.carencia = response.data.relatorio[0].carencia
        informacoes.value.taxa = response.data.relatorio[0].taxa
        informacoes.value.total_parcelas = response.data.relatorio[0].total_parcelas
        informacoes.value.homologado = response.data.relatorio[0].homologacao
        informacoes.value.valor_original = response.data.relatorio[0].valor_original
        informacoes.value.reck2 = response.data
        
        totalPagas.value = response.data.total_pagas
        totalNaoPagas.value = response.data.total_pendentes
        totalEmitidas.value = response.data.total
        
        chartInstance  =  new Chart(chartCanvas.value, {
            type: 'bar',
            data: {
            labels: ['Faturas Pagas e não pagas'],
            datasets: [{
                label: 'Parcelas Pagas',
                data: [response.data.total_pagas],
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1
            },
            {
                label: 'Parcelas não Pagas',
                data: [response.data.total_pendentes],
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1
            },
            {
                label: 'Total de Parcelas',
                data: [response.data.total],
                backgroundColor: 'rgba(255, 206, 86, 0.5)', // Amarelo
                borderColor: 'rgba(255, 206, 86, 1)',
                borderWidth: 1
            }]
            },
            options: {
            responsive: true,
            scales: {
                y: {
                beginAtZero: true
                }
            }
            }
        });
    }

    

    const dadosProjeto = ref([]);
    const projetoSelecionado = ref(null);
    const credoresFiltrados = ref([]); 
    
    const rotas = useRouter();
    
    const buscaDados = async () => {
        try {
            const response = await grafico.getAll();
            dadosProjeto.value = response.data;
        } catch (error) {
            console.error("Erro ao buscar dados:", error);
        }
    };
    
    const filtrarCredores = () => {
        exibeForm.value = false
        if (!projetoSelecionado.value) {
            credoresFiltrados.value = [];
            return;
        }
    
        const projeto = dadosProjeto.value.find(projeto => projeto.id === projetoSelecionado.value);
        credoresFiltrados.value = projeto?.relacao?.flatMap(relacao => relacao.credor) || [];
    };
    
    onMounted(() => {
        buscaDados();
    });
    </script>
    
    <style>

.dashReck li {cursor: pointer;  float:left; background-color:#1B3639; width:100%; color:#fff; padding:20px 40px; margin:0 auto; border-radius: 10px;; margin-left: 20px; }
.dashReck li span { font-size:27px; }
    </style>
    